module.exports = __webpack_public_path__ + "static/img/3@2x.12cfc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v17_new_features/3@2x.png
// module id = tVWX
// module chunks = 0